import { Api } from "service/api";

export const getPowerBIPremiumEmbed = async (
    reportId: string,
    workspaceId: string
) => {
    try {
        const API = new Api();
        const response: object | any | null = await API.get(`/powerbi/embed/${reportId}/${workspaceId}`);
        if (!response) {
            throw new Error("No se recibió respuesta del servidor");
        }
        if (!response.embedUrl || !response.accessToken) {
            throw new Error("Respuesta incompleta: faltan embedUrl o accessToken");
        }

        
        return response;
    } catch (error) {
        throw error;
    }
};
